import APIClient from './index';

export const getPublicSales = params => APIClient.get('Offers/public_sales_admin', { params }).then(response => response.data);
export const updatePublicSaleModeration = (sale, updates) =>
  APIClient.put(`Offers/${sale.id}/creator_sales_moderation`, { ...updates, expectedRevision: sale.revision }).then(response => response.data);
